import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["uploadCsv", "uploadErrorCsv", "uploadingCsv", "uploadedCsv", "inputCsv", "dialog"];
  connect() {
    this.modal = bootstrap.Modal.getOrCreateInstance(this.dialogTarget, {
      backdrop: 'static',
      keyboard: false,
    });
  }

  disconnect() {
  }

  open(e) {
    if (!this.modal.isOpened) {
      this.modal.show();
    }
  }

  hide() {
    this.modal.hide();

    this.uploadCsvTarget.classList.remove("d-none");
    this.uploadingCsvTarget.classList.add("d-none");
    this.uploadedCsvTarget.classList.add("d-none");
    this.uploadErrorCsvTarget.classList.add("d-none");
  }

  close(event) {
    if (event.detail.success) {
      this.hide();
    }
  }

  showUploadCsvDialog(event) {
    console.debug(event, this.dialogTarget);
    this.open();
    // setTimeout(() => {
    //   this.inputCsvTarget.click();
    // }, 400);
  }

  formChanged(event) {
    console.log("Upload File changed!! ", event);
    if (event.target.value === "") {
      return;
    }

    event.target.form.requestSubmit();

    this.uploadCsvTarget.classList.add("d-none");
    this.uploadingCsvTarget.classList.remove("d-none");
    this.uploadErrorCsvTarget.classList.add("d-none");
  }

  formSubmitted(event) {
    console.log("Uploaded File!! ", event);
    this.inputCsvTarget.value = "";

    if (event.detail.success) {
      this.uploadingCsvTarget.classList.add("d-none");
      this.uploadedCsvTarget.classList.remove("d-none");
      this.uploadErrorCsvTarget.classList.add("d-none");
    } else {
      this.uploadingCsvTarget.classList.add("d-none");
      this.uploadErrorCsvTarget.classList.remove("d-none");
      this.inputCsvTarget.value = "";
    }
  }
}
